<template>
    <el-container style="width:100%;">
        <el-header>
            <el-form :inline="true" :model="fromMq" ref="fromMq" class="demo-form-inline">
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.MQNAME')" prop="sName">
                            <td-input v-model="fromMq.sName"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.IP')" prop="sIp">
                            <td-input v-model="fromMq.sIp"></td-input>
                            <td-checkbox-group></td-checkbox-group>
                        </el-form-item>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddMQ">{{ $t('common.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :permissions="permissionsQuery"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :hasMutiSelect="false"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-MqInfo
                v-if="dialogMqVisible"
                :isAddData="isAddData"
                :dialogMqVisible="dialogMqVisible"
                :editItem="editItem"
                :title="title"
                @mqDialogClose="mqDialogClose"
                @queryDataList="queryDataList"
            ></dialog-MqInfo>
            <dialog-setup v-if="dialogSetupVisible" :setItem="setItem" :dialogSetupVisible="dialogSetupVisible" :title="setupTitle" @setupDialogClose="setupDialogClose"></dialog-setup>
        </el-main>
    </el-container>
</template>

<script>
import mqApi from './assets/api.js';
import dialogMqInfo from './components/dialogMqInfo.vue';
import dialogSetup from './components/dialogSetup.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-MqInfo': dialogMqInfo,
        'dialog-setup': dialogSetup
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // this.queryDataList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['mq:view'],
            permissionsAdd: ['mq:add'],
            fromMq: { sName: '', sIp: '' },
            editItem: '',
            dialogMqVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            dialogSetupVisible: false,
            columns: [
                {
                    prop: 'sName',
                    label: 'common.MQNAME'
                },
                {
                    prop: 'iType',
                    label: 'common.TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.iType === window.pgCommon.mqType.RABBITMQ) {
                            return createElement('span', this.$t('common.RABBITMQ'));
                        }
                        if (params.row.iType === window.pgCommon.mqType.ACTIVEMQ) {
                            return createElement('span', this.$t('common.ACTIVEMQ'));
                        }
                        return createElement('span', this.$t('common.UNKNOW_TYPE'));
                    }
                },
                {
                    prop: 'sIp',
                    label: 'common.IP',
                    align: 'center'
                },
                {
                    prop: 'iPort',
                    label: 'common.PORT',
                    align: 'center'
                },
                {
                    prop: 'iWebsocketPort',
                    label: 'common.WEBSOCKET_PORT',
                    align: 'center'
                },
                {
                    prop: 'iWebPort',
                    label: 'common.WEB_PORT',
                    align: 'center'
                },
                {
                    prop: 'iSslPort',
                    label: 'pgCommon.MQ_SSL_PORT',
                    align: 'center'
                },
                {
                    prop: 'sUsername',
                    label: 'common.USERNAME',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let a1 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['mq:edit'] },
                                on: {
                                    click: () => {
                                        this.btnExit(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let a2 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['mq:del'] },
                                on: {
                                    click: () => {
                                        this.delete(params.row.sId);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let list = [];
                        list.push(a1);
                        if (params.row.iEnableDeleteFlg === 0) {
                            list.push(a2);
                        }
                        return createElement('div', list);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 根据mq的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryDataList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryDataList();
        },
        queryDataList() {
            let param = {
                sname: this.fromMq.sName,
                sip: this.fromMq.sIp,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            mqApi.listMqInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('mqManagement/listMqInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('mqManagement/listMqInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                //密码为加密时 循环解密显示
                if (response.data !== undefined && !window.vue.$util.isEmpty(response.data.content)) {
                    if (Array.isArray(response.data.content) && response.data.content.length > 0) {
                        if (response.data.content[0].encryption == 1) {
                            var playbackData = window.vue.$util.clone(response.data.content);
                            playbackData.forEach(element => {
                                element.sPassword = window.vue.$util.privateKeydecrypt(element.sPassword);
                            });
                            this.tableData = playbackData;
                        } else {
                            this.tableData = response.data.content;
                        }
                    } else {
                        this.tableData = response.data.content;
                    }
                } else {
                    this.tableData = response.data.content;
                }
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryDataList();
        },
        // 添加
        btnAddMQ() {
            this.title = 'common.ADD'; // 标题
            this.isAddData = true;
            this.dialogMqVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = 'common.EDIT';
            this.isAddData = false;
            this.dialogMqVisible = true;
        },
        // 删除接口
        delete(mqId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { mqId: mqId };
                    mqApi.deleteMqInfo(param, response => {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('mqManagement/deleteMqInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.btnQuery();
                    });
                })
                .catch(() => {});
        },
        // 下传配置
        btnDownload(row) {
            let _this = this;
            _this
                .$confirm(_this.$t('common.CHOOSE_IS_DOWNLOADING_CONFIG'), _this.$t('common.TIPS'), {
                    confirmButtonText: _this.$t('common.SURE'),
                    cancelButtonText: _this.$t('common.CANCEL'),
                    type: 'warning'
                })
                .then(() => {
                    this.dialogSetupVisible = true;
                    this.setupTitle = this.$t('common.DOWNPASS_SETTINGS');
                    this.setItem = row;
                })
                .catch(() => {});
        },
        // 关闭页面
        mqDialogClose() {
            this.dialogMqVisible = false;
        },
        // 关闭页面
        setupDialogClose() {
            this.dialogSetupVisible = false;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    margin-left: 100px;
}
</style>
